import { useCallback, useState } from "react";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";

interface Options {
  priceId: string;
  customerEmail?: string;
  userId?: string;
  returnUrl?: string;
}

export function useStripeCheckout() {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<Options | null>(null);

  const openCheckout = useCallback((opts: Options) => {
    setOptions(opts);
    setIsOpen(true);
  }, []);

  const closeCheckout = useCallback(() => {
    setIsOpen(false);
    setOptions(null);
  }, []);

  const returnUrl =
    options?.returnUrl ??
    `${window.location.origin}/checkout/return?session_id={CHECKOUT_SESSION_ID}&product=${options?.priceId ?? ""}`;

  const checkoutElement =
    isOpen && options ? (
      <div
        className="fixed inset-0 z-[100] flex items-start justify-center bg-black/80 backdrop-blur-sm overflow-y-auto py-10 px-4"
        onClick={closeCheckout}
      >
        <div
          className="w-full max-w-2xl bg-white rounded-lg overflow-hidden relative"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={closeCheckout}
            className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-black/10 hover:bg-black/20 text-black flex items-center justify-center text-lg leading-none"
            aria-label="Close checkout"
          >
            ×
          </button>
          <StripeEmbeddedCheckout
            priceId={options.priceId}
            customerEmail={options.customerEmail}
            userId={options.userId}
            returnUrl={returnUrl}
          />
        </div>
      </div>
    ) : null;

  return { openCheckout, closeCheckout, isOpen, checkoutElement };
}
